/**
 * Definition tab — rule-based concept group's definition body.
 *
 * Only rendered when `artifact.definition` is set (the parent drawer
 * gates the tab visibility); the tab body therefore always has a
 * definition to render. SQL definitions go through the
 * knowledge-link-aware code renderer; markdown definitions go through
 * the standard markdown renderer.
 */

import { Box } from '@mui/material';

import type { EpiArtifact } from '../../types/epi-chat-types';
import { CodeWithKnowledgeLinks } from '../CodeWithKnowledgeLinks';
import { Markdown } from '../Markdown';

export const DefinitionTab = ({ artifact }: { artifact: EpiArtifact }) => {
  const def = artifact.definition;
  if (!def) return null;
  if (def.language === 'sql') {
    return (
      <Box sx={{ height: '100%', overflow: 'auto' }} data-testid="artifact-definition-tab">
        <CodeWithKnowledgeLinks
          language="sql"
          wrapLongLines
          code={def.body}
          customStyle={{
            margin: 0,
            padding: '16px',
            fontSize: '1rem',
            lineHeight: 1.55,
            background: 'transparent',
          }}
        />
      </Box>
    );
  }
  return (
    <Box sx={{ padding: 2 }} data-testid="artifact-definition-tab">
      <Markdown>{def.body}</Markdown>
    </Box>
  );
};
